import api from './api';

// Send offer confirmation email
export const sendOfferConfirmationEmail = async (contractId: number) => {
  try {
    const response = await api.post('/api/clc/offer/send-confirmation', {
      contract_id: contractId
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error('Server responded with an error:', error.response.data);
      return error.response.data;
    } else {
      console.error('Error sending offer confirmation email:', error.message);
      throw error;
    }
  }
};
